export default "__VITE_ASSET__CA0Psa2T__"